/*
 * Redux reducers live here. Read Redux docs for more information:
 * http://redux.js.org/docs/basics/Reducers.html
 */

import { combineReducers } from "redux";

import * as actionTypes from "../actions/actionTypes";

import user from "./user";
import emailPrefs from "./emailPrefs";
import entities from "./entities";
import modals from "./modals";
import paginate from "./paginate";
import notifications from "./notifications";
import apiResponse from "./apiResponse";
import spacePreviews from "./spacePreviews";
import searchV2 from "./searchV2";
import layoutConfig from "./layoutConfig";
import navPoint from "./navPoint";
import viewModes from "./viewModes";
import dragging from "./dragging";
import uploadQueue from "./uploadQueue";
import uploads from "./uploads";
import contentTypes from "./contentTypes";
import trashedItems from "./trashedItems";
import analytics from "./analytics";
import spaceMembers from "./spaceMembers";
import recoveredAssets from "./recoveredAssets";

// Updates the pagination data for different actions.
const pagination = combineReducers({
  kitItems: paginate({
    mapActionToKey: action => action.uuid,
    types: [actionTypes.FETCH_KIT, actionTypes.FETCH_KIT_SUCCESS, actionTypes.FETCH_KIT_FAILURE],
  }),
  sectionItems: paginate({
    mapActionToKey: action => (action.response ? action.response.result : action.uuidv),
    types: [
      actionTypes.FETCH_SECTION,
      actionTypes.FETCH_SECTION_SUCCESS,
      actionTypes.FETCH_SECTION_FAILURE,
    ],
  }),
  kitSearchItems: paginate({
    mapActionToKey: action => action.uuid,
    types: [actionTypes.SEARCH_KIT, actionTypes.SEARCH_KIT_SUCCESS, actionTypes.SEARCH_KIT_FAILURE],
  }),
  kitTrashedItems: paginate({
    mapActionToKey: action => action.uuid,
    types: [
      actionTypes.FETCH_KIT_RECENTLY_DELETED,
      actionTypes.FETCH_KIT_RECENTLY_DELETED_SUCCESS,
      actionTypes.FETCH_KIT_RECENTLY_DELETED_FAILURE,
    ],
  }),
  kitRecoveredAssets: paginate({
    mapActionToKey: action => action.uuid,
    types: [
      actionTypes.FETCH_KIT_RECOVERED_ASSETS,
      actionTypes.FETCH_KIT_RECOVERED_ASSETS_SUCCESS,
      actionTypes.FETCH_KIT_RECOVERED_ASSETS_FAILURE,
    ],
  }),
  kitMembers: paginate({
    mapActionToKey: action => action.kitUuid,
    types: [
      actionTypes.FETCH_KIT_MEMBERS,
      actionTypes.FETCH_KIT_MEMBERS_SUCCESS,
      actionTypes.FETCH_KIT_MEMBERS_FAILURE,
    ],
  }),
  spaceKits: paginate({
    mapActionToKey: action => String(action.id),
    types: [
      actionTypes.FETCH_SPACE_KITS,
      actionTypes.FETCH_SPACE_KITS_SUCCESS,
      actionTypes.FETCH_SPACE_KITS_FAILURE,
    ],
  }),
  spaceKitCollections: paginate({
    mapActionToKey: action => String(action.id),
    types: [
      actionTypes.FETCH_KIT_COLLECTIONS,
      actionTypes.FETCH_KIT_COLLECTIONS_SUCCESS,
      actionTypes.FETCH_KIT_COLLECTIONS_FAILURE,
    ],
  }),
  billingHistory: paginate({
    mapActionToKey: action => String(action.spaceId),
    types: [
      actionTypes.FETCH_BILLING_HISTORY,
      actionTypes.FETCH_BILLING_HISTORY_SUCCESS,
      actionTypes.FETCH_BILLING_HISTORY_FAILURE,
    ],
  }),
  search: paginate({
    mapActionToKey: action => Object.keys(action.query.queries).map(q => `${action.spaceId}-${q}`),
    types: [
      actionTypes.SUBMIT_SEARCH_QUERY,
      actionTypes.SUBMIT_SEARCH_QUERY_SUCCESS,
      actionTypes.SUBMIT_SEARCH_QUERY_FAILURE,
    ],
  }),
});

const rootReducer = combineReducers({
  user,
  emailPrefs,
  entities,
  pagination,
  modals,
  apiResponse,
  notifications,
  spacePreviews,
  searchV2,
  layoutConfig,
  navPoint,
  viewModes,
  dragging,
  uploadQueue,
  uploads,
  contentTypes,
  trashedItems,
  recoveredAssets,
  analytics,
  spaceMembers,
});

export default rootReducer;
